import { OrganizationMemberClientAccessSort } from "@common/types/organizationMemberClientAccess";

export const DEFAULT_MEMBER_ACCESS_LOG_SORT =
    OrganizationMemberClientAccessSort.CREATED_AT_DESC;
